const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const GetAllRoles = "UserManagement/GetAllRoles"
const GetCategories = "Common/GetCategories"
const GetCategorieTypesDescription = "Common/UpdateCategoriesAndTypes"
const GetChatSessions = 'ChatSession/GetChatSessions'
const GetChatsThroughUserId = 'ChatSession/GetChatsThroughUserId'
const GetIPAddress = 'Common/GetIPAddress'
const PostPrompt = 'Prompt/PostPrompt'

export const ApiUrls = {
  GetUsers,
  GetUserRoles,
  SaveUserRoles,
  GetAllRoles,
  GetCategories,
  GetCategorieTypesDescription,
  GetChatSessions,
  GetChatsThroughUserId,
  GetIPAddress,
  PostPrompt
}
